import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import axios from "axios";
import "vue-loading-overlay/dist/vue-loading.css";
import { request } from "@/js/http/http_request";
import { scrollTo } from "@/js/animation.js";
import * as orderHandler from "@/js/order/order.js";
import { REGULAR_BOTTLING, listWineTypes, listBodyStructures, listWineRangeAccessibility, alcoholLevelCategories, listCurrencies, casingWines, bottlings, StringHsCode, wineErrors, conciergerieTypesRequest, wineRarities, listContinents, stockReservationTypes, tenantType, documentTypes, buyLimitErrors, TASTING_PHOTOS, DOCUMENT_TAGS } from "@/js/lists.ts";
import { getErrorData, filterVAutocomplete, ERROR_DATA, handleErrorData } from "@/js/forms.js";
import { hasRole, isUserBuyerGroup, isAdminNotConsultant, isConsultantOrHolding, isConsultantNotHolding, isIndividual, hasBypassBuyLimit, getLimitedLocations } from "@/js/http/auth.js";
import { displayPrice, getIdCurrencyUsedForCartAndExplore, formatEurPriceInUsedCurrencyForCartAndExplore, formatPrice } from "@/js/currency/currencies.js";
import { regexpDecimal, regexpInt, regexpHsCode, regexpTtb, regExpReferenceWarehouse } from "@/js/regexp_validation.js";
import { wineNaming, casingForAdmin } from "@/js/wine/wine.js";
import { filterDecimalKey } from "@/js/events/keycodes.js";
import { userHasByPassLimit, hasAccessGranted } from "@/js/user/user.js";
import Map from "@/components/map/Map.vue";
import WineAddCartButton from "@/components/products/WineAddCartButton.vue";
import WineNaming from "@/components/products/WineNaming.vue";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import commentComponent from "@/components/comment/CommentComponent.vue";
import RatingComponent from "@/components/rating/RatingComponent.vue";
import Uploader from "@/components/default/UploaderComponent.vue";
import TargetSelectors from "@/components/order/TargetSelector/TargetSelectors.vue";
import UploaderV2 from "@/components/default/UploaderV2.vue";
import WineStockListModal from "@/components/products/WineStockListModal.vue";
import ManageDocumentsTagsDialog from "@/components/document-tags/ManageDocumentsTagsDialog.vue";
import AddTagToDocumentDialog from "@/components/document-tags/AddTagToDocumentDialog.vue";
import ConditionalDiscountModal from "@/components/conditionaldiscount/ConditionalDiscountModal.vue";
import ConditionalDiscountV2Modal from "@/components/conditionaldiscount/ConditionalDiscountV2Modal.vue";
import WineDiscountTooltip from "@/components/products/WineDiscountTooltip.vue";
import WineDuplicateListDialog from "@/components/products/WineDuplicateListDialog.vue";
import AppellationPopin from "@/components/appellation/AppellationPopin.vue";
import DosagePopin from "@/components/appellation/DosagePopin.vue";
import DenominationPopin from "@/components/appellation/DenominationPopin.vue";
import WineSupplierPriceModal from "@/components/supplier-prices/WineSupplierPriceModal.vue";
import WineRangeAccessibility from "@/components/products/WineRangeAccessibility.vue";
import ScheduledWineCogsModal from "@/components/products/ScheduledWineCogsModal.vue";
import RegionFormModal from "@/components/region/RegionFormModal";
import WineCogsHistoryModal from "@/components/products/WineCogsHistoryModal.vue";
import PricePostedUsaEditModal from "@/components/price-posting/usa-pro/PricePostedUsaEditModal.vue";
import SupplierSelectComponent from "@/components/supplier-prices/SupplierSelectComponent.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  name: "ProductDetails",
  components: {
    Map: Map,
    Uploader: Uploader,
    "wine-add-cart-btn": WineAddCartButton,
    "wine-naming": WineNaming,
    confirm: confirmationComponent,
    comment: commentComponent,
    rating: RatingComponent,
    TargetSelectors: TargetSelectors,
    UploaderV2: UploaderV2,
    WineStockListModal: WineStockListModal,
    AddTagToDocumentDialog: AddTagToDocumentDialog,
    ManageDocumentsTagsDialog: ManageDocumentsTagsDialog,
    ConditionalDiscountModal: ConditionalDiscountModal,
    ConditionalDiscountV2Modal: ConditionalDiscountV2Modal,
    WineDiscountTooltip: WineDiscountTooltip,
    WineDuplicateListDialog: WineDuplicateListDialog,
    AppellationPopin: AppellationPopin,
    DosagePopin: DosagePopin,
    DenominationPopin: DenominationPopin,
    WineSupplierPriceModal: WineSupplierPriceModal,
    WineRangeAccessibility: WineRangeAccessibility,
    ScheduledWineCogsModal: ScheduledWineCogsModal,
    RegionFormModal: RegionFormModal,
    WineCogsHistoryModal: WineCogsHistoryModal,
    ErrorModal: ErrorModal,
    PricePostedUsaEditModal: PricePostedUsaEditModal,
    SupplierSelectComponent: SupplierSelectComponent
  },
  props: ["idWine", "type", "loggedUserData", "cellarWine", "producerIdInPO", "supplierPrice", "wineForCloning"],
  data: function data(_this) {
    return {
      canEditCogs: false,
      canManageStock: false,
      canManagePricePosting: false,
      canEditDiscounts: false,
      discountsHasAccessToNewInterface: false,
      zoomerOptions: {
        zoomFactor: 1.1,
        pane: "container-round",
        hoverDelay: 200,
        namespace: "inline-round-zoomer",
        move_by_click: true,
        scroll_items: 1,
        choosed_thumb_border_color: "#bbdefb"
      },
      drawer: false,
      wineDocuments: [],
      isLoadingFiles: false,
      isMakingDrawerStateless: false,
      gettingDocumentTags: {
        isPending: false,
        cancellationToken: null,
        results: []
      },
      uploadAdditionalData: {
        tagId: null
      },
      isLoadingWine: false,
      getWineCancellationToken: null,
      loaded: false,
      canManage: false,
      isCloning: false,
      routeName: _this.loggedUserData.userGroup === "ADMIN" ? "adminProducerDetails" : "userProducerDetails",
      producers: [],
      regions: [],
      classifications: [],
      dosages: [],
      ranges: [],
      suppliers: [],
      fetchSuppliersToken: null,
      addQuantity: 1,
      isAddingToCart: [],
      currency: "EUR",
      thirdPartyOrder: false,
      wine: {
        alcohol_level_category: null,
        vineyard_size: "",
        average_yield: null,
        id_wine: null,
        name: "",
        year: null,
        type: null,
        cuvee: null,
        dosage: null,
        price: null,
        bottling: null,
        casings: [],
        hs_code: "2204",
        rangeAccessibility: null,
        accountancy_code: null,
        bypass_appellation_doublon: false,
        buy_limit: null,
        has_limited_quantity: false,
        rarity: wineRarities.DEFAULT.id,
        is_active: null,
        producer: {
          id: "",
          name: ""
        },
        appellation: {
          name: "",
          denominations: []
        },
        region: {
          name: "",
          appellations: []
        },
        regionSub: {
          id: null,
          name: null
        },
        address: {
          state: "",
          country: ""
        },
        naming_data: {
          wine_type: null,
          winery: "",
          appellation: "",
          classification: "",
          denomination: "",
          cuvee: "",
          dosage: "",
          vintage: "",
          bottling: ""
        },
        details: {
          composition: "",
          cooperage: "",
          aging_potential: "",
          vignification: "",
          winemaker_note: "",
          description: "",
          soil: "",
          orientation: "",
          temperature: "",
          service_advice: ""
        },
        remove_main_image: false,
        supplierPrice: {
          supplierId: null,
          price: 0.0,
          isCreateSupplierPriceLater: false
        }
      },
      newExternalIdIsConfiguring: false,
      newExternalId: {
        externalPlatformName: "HAL",
        externalPlatformId: ""
      },
      originalWine: null,
      lastWineType: null,
      casings: [],
      defaultCasing: "",
      casingIdSelected: "",
      wineNamingBoolRender: false,
      cloningOptions: {
        wineBaseId: 0,
        transferConditionalDiscounts: false,
        transferCommissions: false,
        transferCogs: false
      },
      error: {
        name: "",
        producer: "",
        vintage: "",
        type: "",
        region: "",
        regionSub: "",
        appellation: "",
        composition: "",
        note: "",
        bottling: "",
        supplierSelect: "",
        supplierPrice: "",
        cogs_euro_ex_vat: "",
        rangeAccessibility: "",
        rarity: "",
        alcohol_level_category: "",
        casing: "",
        hs_code: "",
        id_ttb: "",
        accountancy_code: "",
        buy_limit: "",
        clone: "",
        buy_limit_casing: "",
        cuvee: ""
      },
      errorMessages: {
        mandatory: "This field is required",
        vintage: {
          format: "Incorrect format, valid year expected (example: 2000)",
          date: "Sorry we have not referenced the future wines to be sold yet"
        },
        cogs_euro_ex_vat: {
          format: "Incorrect format, valid price with 2 decimals maximum expected (example : 100.00)",
          null: "COGS cannot be set at 0.00 €, the minimum price must be 0.01 €."
        },
        alcohol_level_category: {
          format: "Please select a valid alcohol level"
        },
        casing: {
          format: "Please select a valid casing for this wine",
          size: "Casing unavailable for this size of bottle"
        },
        hs_code: {
          format: "Incorrect format, 4 or 6 or 8 or 10 digits expected",
          must_be_spirit: "Incorrect HsCode for type Spirit",
          must_not_be_spirit: "Incorrect HsCode for type not equal to Spirit"
        },
        id_ttb: {
          format: "The TTB ID must contains 14 digits"
        },
        accountancy_code: {
          format: "Incorrect format, only upper letters, numbers and '-' are allowed (example : DRB-01)"
        },
        buy_limit: {
          format: "Incorrect format, integer expected"
        },
        clone: {
          same: "Please modify at least one field"
        },
        buy_limit_casing: {
          inconsistency: "Inconsistency between casing and buy limit"
        }
      },
      mapFailedLoading: false,
      skuManual: false,
      skuOriginal: "",
      wineRaritiesValues: Object.values(wineRarities),
      thirdPartyUserHasBypassBuyLimit: false,
      isMainImageBroken: false,
      wineStockKey: null,
      currentWine: null,
      currentQuantity: 0,
      discountAmount: 0,
      isConditionalDiscountModalShown: false,
      isConditionalDiscountV2ModalShown: false,
      isWineSupplierPriceModalShown: false,
      isDuplicateListDialogShown: false,
      fetchDuplicateWinesToken: null,
      duplicateWines: [],
      initialCogs: null,
      isCogsHistoryShow: false,
      appellationPopinShown: false,
      dosagePopinShown: false,
      denominationPopinShown: false,
      isGrantedAccessibility: false,
      isScheduledCogsModalShown: false,
      isPrecisingAlcoholLevel: false,
      tastingPhotos: {
        canManage: false,
        required: {
          isSearchPending: false,
          items: []
        },
        upload: {
          isComponentCreated: false,
          tastingPhotoRequiredId: null
        }
      },
      regionForm: {
        canManageRegions: false,
        editedId: null,
        initAddFormValues: null,
        refreshingList: {
          isPending: false
        }
      },
      producerList: {
        canManage: false,
        isPending: false
      },
      listWineTypes: listWineTypes,
      listBodyStructures: listBodyStructures,
      alcoholLevelCategories: alcoholLevelCategories,
      listCurrencies: listCurrencies,
      casingWines: casingWines,
      bottlings: bottlings,
      StringHsCode: StringHsCode,
      listContinents: listContinents,
      wineErrors: wineErrors,
      stockReservationTypes: stockReservationTypes,
      tenantType: tenantType,
      documentTypes: documentTypes,
      listWineRangeAccessibility: listWineRangeAccessibility,
      ERROR_DATA: ERROR_DATA
    };
  },
  watch: {
    "wine.supplierPrice.isCreateSupplierPriceLater": function wineSupplierPriceIsCreateSupplierPriceLater(newValue) {
      if (newValue === true) {
        this.wine.supplierPrice.price = null;
        this.wine.supplierPrice.supplierId = null;
        this.error.supplierPrice = "";
        this.error.supplierSelect = "";
      }
    }
  },
  computed: {
    uploadUrl: function uploadUrl() {
      return "".concat(process.env.VUE_APP_API_URL, "/v1/uploader/wine/").concat(this.wine.id_wine, "/files");
    },
    uploadAdditionalFormData: function uploadAdditionalFormData() {
      return _objectSpread({}, this.uploadAdditionalData);
    },
    wineImageProcessUrl: function wineImageProcessUrl() {
      return process.env.VUE_APP_WINE_IMAGE_PROCESS_URL;
    },
    displayBuyLimit: function displayBuyLimit() {
      return this.wine.has_limited_quantity;
    },
    canPurchaseWine: function canPurchaseWine() {
      return this.isGrantedAccessibility || hasRole(process.env.VUE_APP_ROLES_BYPASS_RANGE_ACCESSIBILITY);
    },
    canManageSupplierPrices: function canManageSupplierPrices() {
      return isAdminNotConsultant(this.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_MANAGE_SUPPLIER_PRICES);
    },
    wineInfoLimited: function wineInfoLimited() {
      var _this2 = this;
      if (!!this.wine.rarity) {
        var wineInfoText = this.wineRaritiesValues.find(function (x) {
          return x.id == _this2.wine.rarity;
        }).wineInfoText;
        if (!!wineInfoText && this.displayBuyLimit) {
          return wineInfoText + ". Quantity limited";
        } else if (!!wineInfoText && !this.displayBuyLimit) {
          return wineInfoText;
        } else if (!wineInfoText && this.displayBuyLimit) {
          return "Quantity limited";
        }
      }
      return null;
    },
    wineImage: function wineImage() {
      return {
        thumbs: [{
          id: this.wine.id_wine,
          url: null
        }],
        normal_size: [{
          id: this.wine.id_wine,
          url: this.wine.image
        }]
      };
    },
    producerAddress: function producerAddress() {
      return "".concat(this.wine.producer.address.street, ", ") + "".concat(this.wine.producer.address.city, " ") + "".concat(this.wine.producer.address.zip, ", ") + "".concat(this.wine.producer.address.country.printable_name);
    },
    cadastreName: function cadastreName() {
      var _this$wine$appellatio, _this$wine$denominati, _this$wine$denominati2;
      return "".concat((_this$wine$appellatio = this.wine.appellation) === null || _this$wine$appellatio === void 0 ? void 0 : _this$wine$appellatio.label, " ").concat((_this$wine$denominati = (_this$wine$denominati2 = this.wine.denomination) === null || _this$wine$denominati2 === void 0 ? void 0 : _this$wine$denominati2.appellation) !== null && _this$wine$denominati !== void 0 ? _this$wine$denominati : "");
    },
    skuGenerated: function skuGenerated() {
      var _this$wine$producer,
        _this$wine$appellatio2,
        _this3 = this,
        _this$wine$appellatio3,
        _this$wine$denominati3;
      //CHANGE => api.WineDTO.GenerateAutomaticSku()
      if (this.readOnly || !this.wine) return null;
      var skuWinery = ((_this$wine$producer = this.wine.producer) === null || _this$wine$producer === void 0 ? void 0 : _this$wine$producer.skuAcronym) || "NOWINERYSKU";
      var skuAppellation = "";
      var classification = "";
      if ((_this$wine$appellatio2 = this.wine.appellation) !== null && _this$wine$appellatio2 !== void 0 && _this$wine$appellatio2.id_classification) {
        var _this$classifications;
        classification = (_this$classifications = this.classifications.find(function (x) {
          return x.id_classification == _this3.wine.appellation.id_classification;
        })) === null || _this$classifications === void 0 ? void 0 : _this$classifications.label;
      }
      if ((_this$wine$appellatio3 = this.wine.appellation) !== null && _this$wine$appellatio3 !== void 0 && _this$wine$appellatio3.id_appellation) {
        var appellation = this.wine.appellation.label;
        if (classification) appellation = appellation.replace(" " + classification, "");
        skuAppellation += String.removeDiacritics(String.getFirstLetters(appellation));
      }
      if ((_this$wine$denominati3 = this.wine.denomination) !== null && _this$wine$denominati3 !== void 0 && _this$wine$denominati3.id_appellation) {
        skuAppellation += String.removeDiacritics(String.getFirstLetters(this.wine.denomination.appellation));
      }
      if (this.wine.cuvee) {
        skuAppellation += String.removeDiacritics(String.getFirstLetters(this.wine.cuvee));
      }
      if (this.wine.dosage) {
        skuAppellation += String.removeDiacritics(String.getFirstLetters(this.dosages.find(function (x) {
          return x.id_dosage == _this3.wine.dosage;
        }).label));
      }
      if (classification) {
        skuAppellation += String.removeDiacritics(String.getFirstLetters(classification));
      }
      if (!skuAppellation) skuAppellation = "NOAPPELLATION";
      var skuSuffix = this.getWineType(this.wine.type) ? this.getWineType(this.wine.type)[0] : "";
      skuSuffix += !this.wine.year || isNaN(this.wine.year) ? "NV" : this.wine.year.toString().slice(-2);
      switch (this.wine.bottling) {
        case 375:
          skuSuffix += "HALF";
          break;
        case 1500:
          skuSuffix += "MAG";
          break;
        case 3000:
          skuSuffix += "JERO";
          break;
        case 4500:
          skuSuffix += "REHO";
          break;
        case 5000:
          skuSuffix += "L5";
          break;
        case 6000:
          skuSuffix += "MATU";
          break;
        case 9000:
          skuSuffix += "SALM";
          break;
      }
      return (skuWinery + "-" + skuAppellation + "-" + skuSuffix).toUpperCase();
    },
    routerLinkConciergerie: function routerLinkConciergerie() {
      return {
        name: "userConciergerie",
        query: {
          message: "I would like information about the availability of the following product " + wineNaming(this.$whitelabel, this.wine.naming_data, true, true),
          conciergerieType: conciergerieTypesRequest.find(function (x) {
            return x.text == "Specific product and/or vintage";
          }).contact_type
        }
      };
    },
    wineIsDeleted: function wineIsDeleted() {
      return !!this.wine.id_wine && this.wine.deleted;
    },
    wineIsSparkling: function wineIsSparkling() {
      var _listWineTypes$find;
      return !!this.wine.type && +this.wine.type === +((_listWineTypes$find = listWineTypes.find(function (x) {
        return x.name === "Sparkling";
      })) === null || _listWineTypes$find === void 0 ? void 0 : _listWineTypes$find.id);
    },
    wineIsSpirit: function wineIsSpirit() {
      var _listWineTypes$find2;
      return !!this.wine.type && +this.wine.type === +((_listWineTypes$find2 = listWineTypes.find(function (x) {
        return x.name === "Spirit";
      })) === null || _listWineTypes$find2 === void 0 ? void 0 : _listWineTypes$find2.id);
    },
    displayListProducers: function displayListProducers() {
      if (this.wineIsSpirit) {
        return this.producers.filter(function (x) {
          return x.isDistillery === true;
        });
      } else {
        return this.producers.filter(function (x) {
          return x.isWinery === true;
        });
      }
    },
    displayListRegions: function displayListRegions() {
      if (this.wineIsSpirit) {
        return this.regions.filter(function (x) {
          return x.isSpiritRegion === true;
        });
      } else {
        return this.regions.filter(function (x) {
          return x.isWineRegion === true;
        });
      }
    },
    displayListAppellations: function displayListAppellations() {
      if (this.wineIsSpirit) {
        return this.wine.region.appellations.filter(function (x) {
          return x.isSpirit === true;
        });
      } else {
        return this.wine.region.appellations.filter(function (x) {
          return x.isWine === true;
        });
      }
    },
    hasRoleToManage: function hasRoleToManage() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_WINE_ADMIN);
    },
    isAddWine: function isAddWine() {
      var _this$wine;
      return !(this.idWine > 0) && !((_this$wine = this.wine) !== null && _this$wine !== void 0 && _this$wine.id_wine);
    },
    isEditWine: function isEditWine() {
      return this.hasRoleToManage && !this.isAddWine && !this.isCloning;
    },
    canManageAppellations: function canManageAppellations() {
      return isAdminNotConsultant(this.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_MANAGE_APPELLATION);
    },
    isSoldOutDisplayed: function isSoldOutDisplayed() {
      var _this4 = this;
      if (isAdminNotConsultant(this.loggedUserData) && this.wine.stocks.length === 0) {
        return true;
      }
      return !isAdminNotConsultant(this.loggedUserData) && (!this.wine.stock_quantity || !this.wine.casings.some(function (wc) {
        return _this4.wine.stock_quantity >= wc.quantity;
      }));
    },
    isStockIncompatible: function isStockIncompatible() {
      return isAdminNotConsultant(this.loggedUserData) && this.wine.stock_quantity === 0 && this.wine.stocks.length > 0 && this.wine.stocks.some(function (ws) {
        return ws.stock_quantity > 0;
      });
    },
    casingsAvailable: function casingsAvailable() {
      return this.wine.casings;
    },
    listSubRegions: function listSubRegions() {
      var _this$wine$region,
        _this5 = this;
      if ((_this$wine$region = this.wine.region) !== null && _this$wine$region !== void 0 && _this$wine$region.subRegions) {
        var _this$wine$region2;
        return (_this$wine$region2 = this.wine.region) === null || _this$wine$region2 === void 0 ? void 0 : _this$wine$region2.subRegions;
      }
      if (this.regions && this.wine.region) {
        var _this$regions$find;
        return (_this$regions$find = this.regions.find(function (x) {
          return x.id == _this5.wine.region.id;
        })) === null || _this$regions$find === void 0 ? void 0 : _this$regions$find.subRegions;
      }
      return [];
    }
  },
  created: function created() {
    var _this6 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this6$wineForCloning;
      var _listWineTypes$find3;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            /* this.$EventBus.$on("mapFailedLoading", () => {
              this.mapFailledLoading = true
            }) */

            _this6.canManageStock = isAdminNotConsultant(_this6.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_MANAGE_STOCK);
            _this6.canManagePricePosting = isAdminNotConsultant(_this6.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_MANAGE_PRICE_POSTING);
            _this6.canEditCogs = isAdminNotConsultant(_this6.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_MANAGE_WINE_COGS);
            _this6.canEditDiscounts = isAdminNotConsultant(_this6.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_MANAGE_WINE_DISCOUNTS);
            _this6.discountsHasAccessToNewInterface = _this6.canEditDiscounts;
            _this6.thirdPartyOrder = hasRole(process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER);
            _this6.tastingPhotos.canManage = isAdminNotConsultant(_this6.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_MANAGE_TASTING_PHOTOS) || !isAdminNotConsultant(_this6.loggedUserData);
            _this6.regionForm.canManageRegions = hasRole(process.env.VUE_APP_ROLES_MANAGE_APPELLATION);
            _this6.producerList.canManage = hasRole(process.env.VUE_APP_ROLES_MANAGE_PRODUCERS);
            if (_this6.$props.idWine && _this6.$route.params.id !== "new") {
              _this6.wine.id_wine = _this6.$props.idWine;
            } else {
              // Pre-activate for friendly use
              _this6.wine.is_active = true;
              if (_this6.type === "spirit") {
                _this6.wine.type = +((_listWineTypes$find3 = listWineTypes.find(function (x) {
                  return x.name === "Spirit";
                })) === null || _listWineTypes$find3 === void 0 ? void 0 : _listWineTypes$find3.id);
              }
            }
            orderHandler.refreshCategoryUser(_this6);
            _context.next = 13;
            return _this6.getWine();
          case 13:
            _this6.$EventBus.$on("refresh_category_user", function (value) {
              _this6.isGrantedAccessibility = hasAccessGranted(_this6.wine.rangeAccessibility);
            });
            if (_this6.canManage) {
              _this6.fetchSuppliers();
              if (_this6.wine.id_wine) {
                _this6.fetchWineDocuments();
                _this6.fetchDocumentTags();
              }
            }
            _this6.currency = getIdCurrencyUsedForCartAndExplore();
            _this6.getRequiredTastingPhotos();
            if (((_this6$wineForCloning = _this6.wineForCloning) === null || _this6$wineForCloning === void 0 ? void 0 : _this6$wineForCloning.wineIdForCloning) > 0) {
              _this6.callToClone();
              if (_this6.wineForCloning.wine.vintage > 0) {
                _this6.wine.year = _this6.wineForCloning.wine.vintage;
              }
              if (_this6.wineForCloning.wine.bottling > 0) {
                _this6.wine.bottling = _this6.wineForCloning.wine.bottling;
              }
            }
            _this6.refreshUnitPriceAccordingToQuantity();
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    handleImages: function handleImages(files) {
      var _files$shift$base, _files$shift;
      this.wine.new_image = (_files$shift$base = files === null || files === void 0 || (_files$shift = files.shift()) === null || _files$shift === void 0 ? void 0 : _files$shift.base64) !== null && _files$shift$base !== void 0 ? _files$shift$base : "";
    },
    isBuyer: function isBuyer() {
      return hasRole(process.env.VUE_APP_ROLES_BUYER) || hasRole(process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER);
    },
    getWine: function getWine() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this$wineForCloning, _this$getWineCancella;
        var _this, url, hasStartedQuerySupp, _third_party_user_selected, pricePostingSelected, response, third_party_user_selected;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this7.$EventBus.$emit("loading", true);
              _this = _this7;
              _this.casings = [];
              url = "/v1/wine/";
              if ((_this$wineForCloning = _this.wineForCloning) !== null && _this$wineForCloning !== void 0 && _this$wineForCloning.wineIdForCloning) {
                _this.wine.id_wine = _this.wineForCloning.wineIdForCloning;
              }
              hasStartedQuerySupp = false;
              if (_this.wine.id_wine) {
                url += _this.wine.id_wine;
                _third_party_user_selected = orderHandler.getThirdPartyUserSelected();
                if (_third_party_user_selected) {
                  url += (hasStartedQuerySupp ? "&" : "?") + "idUserTarget=" + _third_party_user_selected.id_user;
                  hasStartedQuerySupp = true;
                }
                url += (hasStartedQuerySupp ? "&" : "?") + "isApplyActivePricePostingByDefault=false";
                hasStartedQuerySupp = true;
                pricePostingSelected = orderHandler.getPricePostingUsaSelected();
                if (!!pricePostingSelected) {
                  url += (hasStartedQuerySupp ? "&" : "?") + "pricePostingUsaProId=" + pricePostingSelected.id;
                  hasStartedQuerySupp = true;
                }
                if (!_this.hasRoleToManage) {
                  url += (hasStartedQuerySupp ? "&" : "?") + "excludeLinkedData=true";
                  hasStartedQuerySupp = true;
                }
              }
              (_this$getWineCancella = _this.getWineCancellationToken) === null || _this$getWineCancella === void 0 || _this$getWineCancella.cancel();
              _this.getWineCancellationToken = axios.CancelToken.source();
              _context2.next = 11;
              return request(url, "get", null, true, "api", null, _this.getWineCancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, null, true);
                  handleErrorData(_this, errorData);
                  _this.isLoadingWine = false;
                  _this.$EventBus.$emit("loading", false);
                }
                throw e;
              });
            case 11:
              response = _context2.sent;
              if (_this7.hasRoleToManage) {
                _this7.producers = _toConsumableArray(response.data.producers);
                if (!!_this7.producerIdInPO) {
                  _this7.producers = _this7.producers.filter(function (x) {
                    return x.id === _this7.producerIdInPO;
                  });
                }
                _this7.regions = _toConsumableArray(response.data.regions.map(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    displayName: "".concat(x.country.printable_name, " / ").concat(x.name)
                  });
                }));
                _this7.classifications = _toConsumableArray(response.data.classifications);
                _this7.dosages = _toConsumableArray(response.data.dosages);
                _this7.ranges = _toConsumableArray(response.data.ranges);
              }
              if (response.data.wine) {
                _this7.currentRange = _this7.ranges.find(function (x) {
                  return x.id_range === response.data.wine.id_range;
                });
              }
              if (response.data.wine) {
                _this7.wine = _objectSpread(_objectSpread({}, response.data.wine), {}, {
                  region: _objectSpread(_objectSpread({}, response.data.wine.region), {}, {
                    displayName: "".concat(response.data.wine.region.country.printable_name, " / ").concat(response.data.wine.region.name)
                  })
                });
                _this7.skuOriginal = _this7.wine.accountancy_code;
                _this7.isPrecisingAlcoholLevel = !!_this7.wine.alcohol_level;
                _this7.wine.casings.map(function (x) {
                  _this7.casings.push(x.casingId);
                  if (x.isDefault) {
                    _this7.defaultCasing = x.casingId;
                  }
                  if (x.quantity <= _this7.wine.stock_quantity) {
                    if (!_this7.casingIdSelected || x.isDefault) {
                      _this7.casingIdSelected = x.casingId;
                    }
                  }
                  x.textCard = casingWines.find(function (y) {
                    return y.value == x.casingId;
                  }).textCard;
                  return x;
                });
                _this7.wine.casings.sort(function (a, b) {
                  return a.quantity - b.quantity;
                });
                if (isAdminNotConsultant(_this7.loggedUserData) && !_this7.wine.casings.some(function (x) {
                  return x.quantity == 1;
                })) {
                  _this7.wine.casings.unshift(casingForAdmin());
                  if (!_this7.casingIdSelected) {
                    _this7.casingIdSelected = _this7.wine.casings[0].casingId;
                  }
                }
                if (!_this7.casingIdSelected) {
                  _this7.casingIdSelected = _this7.defaultCasing;
                }
                _this7.setInitialCogs();
              }
              _this7.canManage = !isUserBuyerGroup(_this7.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_MANAGE_WINE_ADMIN);
              if (_this7.producerIdInPO) {
                _this7.wine.producer = _this7.producers.find(function (x) {
                  return x.id == _this7.producerIdInPO;
                });
              }
              third_party_user_selected = orderHandler.getThirdPartyUserSelected();
              if (!third_party_user_selected) {
                _context2.next = 22;
                break;
              }
              _context2.next = 21;
              return userHasByPassLimit(third_party_user_selected.id_user);
            case 21:
              _this7.thirdPartyUserHasBypassBuyLimit = _context2.sent;
            case 22:
              _this7.isGrantedAccessibility = hasAccessGranted(_this7.wine.rangeAccessibility);
              _this7.lastWineType = _this7.wine.type;
              _this7.loaded = true;
              _this7.isLoadingWine = false;
              _this7.$EventBus.$emit("loading", false);
              _this7.refreshUnitPriceAccordingToQuantity();
            case 28:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getWineType: function getWineType(type) {
      if (type) {
        return listWineTypes.find(function (x) {
          return x.id === type;
        }).name;
      }
      return "";
    },
    getBodyStructure: function getBodyStructure(body) {
      if (body) {
        return this.listBodyStructures.find(function (x) {
          return x.structure == body;
        }).text;
      }
      return "";
    },
    changeRegion: function changeRegion() {
      this.wine.appellation = {};
      this.wine.denomination = {};
    },
    changeAppellation: function changeAppellation() {
      this.wine.denomination = {};
    },
    changeDenomination: function changeDenomination() {
      this.wine = _objectSpread({}, this.wine);
    },
    changeType: function changeType() {
      var _listWineTypes$find4;
      if (!this.wineIsSparkling) {
        this.wine.dosage = null;
      }
      if (this.wineIsSpirit) {
        this.wine.denomination = null;
        this.wine.vineyard_size = null;
        this.wine.average_yield = null;
        this.wine.details.soil = null;
        this.wine.details.cooperage = null;
        this.wine.details.orientation = null;
      }
      if (this.lastWineType === +((_listWineTypes$find4 = listWineTypes.find(function (x) {
        return x.name === "Spirit";
      })) === null || _listWineTypes$find4 === void 0 ? void 0 : _listWineTypes$find4.id) || this.wineIsSpirit) {
        this.wine.producer = {};
        this.wine.region = {
          name: null,
          displayName: null,
          appellations: []
        };
        this.wine.appellation = {};
      }
      this.lastWineType = this.wine.type;
    },
    changeProducer: function changeProducer() {
      if (this.isAddWine && this.wine.producer) {
        this.wine.isTastingPhotoRequired = this.wine.producer.isDefaultTastingPhotoRequired;
      }
    },
    changeThirdPartyUserSelected: function changeThirdPartyUserSelected() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _orderHandler$getThir;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this8.isLoadingWine = true;
              _this8.currency = getIdCurrencyUsedForCartAndExplore();
              _this8.getWine();
              _this8.refreshUnitPriceAccordingToQuantity();
              _context3.next = 6;
              return userHasByPassLimit((_orderHandler$getThir = orderHandler.getThirdPartyUserSelected()) === null || _orderHandler$getThir === void 0 ? void 0 : _orderHandler$getThir.id_user);
            case 6:
              _this8.thirdPartyUserHasBypassBuyLimit = _context3.sent;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    changePricePostingSelected: function changePricePostingSelected() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this9.getWine();
              _this9.refreshUnitPriceAccordingToQuantity();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    toggleSkuManual: function toggleSkuManual() {
      this.skuManual = !this.skuManual;
      if (!this.skuManual) {
        this.wine.accountancy_code = this.skuOriginal;
      }
    },
    getSkuGenerated: function getSkuGenerated() {
      this.wine.accountancy_code = this.skuGenerated;
    },
    getSkuOriginal: function getSkuOriginal() {
      this.wine.accountancy_code = this.skuOriginal;
      this.skuManual = false;
    },
    save: function save() {
      if (!this.wine.id_wine) {
        this.saveWine("post");
      } else if (this.isCloning) {
        this.saveWine("post");
      } else {
        this.saveWine("put");
      }
    },
    saveWine: function saveWine(verb) {
      var _this10 = this;
      if (this.validateInputs()) {
        this.$EventBus.$emit("loading", true);
        if (this.isCloning) {
          this.wine.id_wine = null;
        }
        this.wine.casings = this.casings.map(function (x) {
          return {
            casingId: x,
            isDefault: x == _this10.defaultCasing
          };
        });
        var data = _objectSpread({}, this.wine);
        if (this.isCloning) {
          data.cloningOptions = this.cloningOptions;
        }
        var _this11 = this;
        request("/v1/wine/", verb, data, true, "api").then(/*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(response) {
            return _regeneratorRuntime().wrap(function _callee5$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  if (!(response.status == 201 || response.status == 200)) {
                    _context5.next = 8;
                    break;
                  }
                  if (response.data) _this11.wine.id_wine = response.data;
                  _context5.next = 4;
                  return _this11.getWine();
                case 4:
                  _this11.$toasted.show("Product saved.", {
                    type: "success"
                  });
                  _this11.originalWine = null;
                  _this11.skuManual = false;
                  if (_this11.producerIdInPO || _this11.producerIdInPO === 0 || _this11.supplierPrice) {
                    _this10.$emit("newWineSaved", _this11.wine.id_wine);
                    _this10.$destroy();
                  } else {
                    if (_this11.isCloning) {
                      _this11.isCloning = false;
                      _this11.clearCloningOptions();
                      _this11.$router.push({
                        name: _this11.wineIsSpirit ? "adminSpiritsDetails" : "adminWineDetails",
                        query: {},
                        params: {
                          id: _this11.wine.id_wine
                        }
                      });
                      _this11.wineNamingBoolRender = !_this11.wineNamingBoolRender;
                    } else {
                      _this11.$router.push({
                        query: null,
                        params: {
                          id: _this11.wine.id_wine
                        }
                      });
                    }
                  }
                case 8:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()).catch(function (e) {
          var _e$response, _e$response2;
          if (e !== null && e !== void 0 && (_e$response = e.response) !== null && _e$response !== void 0 && (_e$response = _e$response.data) !== null && _e$response !== void 0 && (_e$response = _e$response.value) !== null && _e$response !== void 0 && _e$response.errorCode && wineErrors[e.response.data.value.errorCode]) {
            var message = wineErrors[e.response.data.value.errorCode];
            if (e.response.data.value.errorCode === "wine_exists") {
              _this11.$toasted.show(message + e.response.data.value.message, {
                type: "warning"
              });
            } else {
              _this11.$toasted.show(message, {
                type: "warning"
              });
            }
            _this11.fetchDuplicateWines();
          } else if (e !== null && e !== void 0 && (_e$response2 = e.response) !== null && _e$response2 !== void 0 && (_e$response2 = _e$response2.data) !== null && _e$response2 !== void 0 && _e$response2.value && typeof e.response.data.value === "string") {
            _this11.$toasted.show(e.response.data.value, {
              type: "warning"
            });
          } else {
            var errorData = getErrorData(e, _this11.managedExceptions, null, true);
            handleErrorData(_this11, errorData);
          }
          _this11.$EventBus.$emit("loading", false);
        });
      }
    },
    scrollToFirstError: function scrollToFirstError() {
      this.$nextTick(function () {
        var firstError = document.querySelector(".errorLabel");
        if (firstError) {
          firstError.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
        }
      });
    },
    validateInputs: function validateInputs() {
      var _this$wine$region3,
        _this12 = this,
        _this$wine$producer2,
        _this$wine$appellatio4;
      var currentErrors = [this.error.length];
      this.resetErrorMessages();
      if (!((_this$wine$region3 = this.wine.region) !== null && _this$wine$region3 !== void 0 && _this$wine$region3.id) > 0) {
        currentErrors.push(this.error.region = this.errorMessages.mandatory);
      }
      if (!this.wine.regionSub.id > 0) {
        currentErrors.push(this.error.regionSub = this.errorMessages.mandatory);
      }
      if (!this.wine.type) {
        currentErrors.push(this.error.type = this.errorMessages.mandatory);
      } else if (this.wineIsSpirit) {
        if (!this.wine.cuvee) {
          currentErrors.push(this.error.cuvee = this.errorMessages.mandatory);
        }
      }
      if (!this.wine.hs_code) {
        currentErrors.push(this.error.hs_code = this.errorMessages.mandatory);
      } else if (!regexpHsCode.test(this.wine.hs_code)) {
        currentErrors.push(this.error.hs_code = this.errorMessages.hs_code.format);
      } else {
        var completeHsCode = StringHsCode.find(function (x) {
          return x.code === _this12.wine.hs_code;
        });
        if (this.wineIsSpirit && !completeHsCode.isSpirit) {
          currentErrors.push(this.error.hs_code = this.errorMessages.hs_code.must_be_spirit);
        } else if (!this.wineIsSpirit && completeHsCode.isSpirit) {
          currentErrors.push(this.error.hs_code = this.errorMessages.hs_code.must_not_be_spirit);
        }
      }
      if (!this.wine.alcohol_level_category) {
        currentErrors.push(this.error.alcohol_level_category = this.errorMessages.mandatory);
      }
      if (!((_this$wine$producer2 = this.wine.producer) !== null && _this$wine$producer2 !== void 0 && _this$wine$producer2.id)) {
        currentErrors.push(this.error.producer = this.errorMessages.mandatory);
      }
      if (!((_this$wine$appellatio4 = this.wine.appellation) !== null && _this$wine$appellatio4 !== void 0 && _this$wine$appellatio4.id_appellation)) {
        currentErrors.push(this.error.appellation = this.errorMessages.mandatory);
      }
      var current_year = new Date().getFullYear();
      if (current_year < this.wine.year) {
        currentErrors.push(this.error.vintage = this.errorMessages.vintage.date);
      }
      if (!this.wine.supplierPrice.isCreateSupplierPriceLater) {
        var _this$wine$supplierPr, _this$wine$supplierPr2;
        if (!((_this$wine$supplierPr = this.wine.supplierPrice) !== null && _this$wine$supplierPr !== void 0 && _this$wine$supplierPr.supplierId) && this.isAddWine) {
          currentErrors.push(this.error.supplierSelect = this.errorMessages.mandatory);
        }
        if (!((_this$wine$supplierPr2 = this.wine.supplierPrice) !== null && _this$wine$supplierPr2 !== void 0 && _this$wine$supplierPr2.price) && this.isAddWine) {
          currentErrors.push(this.error.supplierPrice = this.errorMessages.mandatory);
        }
      }
      if (!this.wine.cogs_euro_ex_vat) {
        currentErrors.push(this.error.cogs_euro_ex_vat = this.errorMessages.mandatory);
      } else if (!regexpDecimal.test(this.wine.cogs_euro_ex_vat)) {
        currentErrors.push(this.error.cogs_euro_ex_vat = this.errorMessages.cogs_euro_ex_vat.format);
      }
      if (this.wine.cogs_euro_ex_vat === 0) {
        currentErrors.push(this.error.cogs_euro_ex_vat = this.errorMessages.cogs_euro_ex_vat.null);
      }
      if (!this.wine.rangeAccessibility) {
        currentErrors.push(this.error.rangeAccessibility = this.errorMessages.mandatory);
      }
      if (!this.wine.rarity) {
        currentErrors.push(this.error.rarity = this.errorMessages.mandatory);
      }
      if (!this.wine.details.composition) {
        currentErrors.push(this.error.composition = this.errorMessages.mandatory);
      }
      if (!this.wine.bottling) {
        currentErrors.push(this.error.bottling = this.errorMessages.mandatory);
      }
      if (!this.defaultCasing || this.casings.length === 0) {
        currentErrors.push(this.error.casing = this.errorMessages.mandatory);
      } else {
        var casing = casingWines.find(function (x) {
          return x.value == _this12.defaultCasing;
        });
        if (!casing || !this.casings.includes(this.defaultCasing)) {
          currentErrors.push(this.error.casing = this.errorMessages.casing.format);
        }
      }
      if (this.wine.id_ttb && !regexpTtb.test(this.wine.id_ttb)) {
        currentErrors.push(this.error.id_ttb = this.errorMessages.id_ttb.format);
      }
      if (!this.wine.accountancy_code) {
        currentErrors.push(this.error.accountancy_code = this.errorMessages.mandatory);
      } else if (!regExpReferenceWarehouse.test(this.wine.accountancy_code)) {
        currentErrors.push(this.error.accountancy_code = this.errorMessages.accountancy_code.format);
      }
      if (this.wine.buy_limit && !regexpInt.test(this.wine.buy_limit)) {
        currentErrors.push(this.error.buy_limit = this.errorMessages.buy_limit.format);
      }
      if (this.isCloning) {
        if (Object.equal(this.originalWine, this.wine)) {
          currentErrors.push(this.error.clone = this.errorMessages.clone.same);
        }
      }
      if (this.wine.buy_limit && this.error.buy_limit.length === 0 && this.error.casing.length === 0) {
        var casingInt = parseInt(this.defaultCasing.match(/\d+/)[0]);
        if (this.wine.buy_limit < casingInt) {
          currentErrors.push(this.error.buy_limit_casing = this.errorMessages.buy_limit_casing.inconsistency);
        }
      }
      if (Object.values(this.error).some(function (val) {
        return val.length > 0;
      })) {
        this.scrollToFirstError();
      }

      // the default size of this empty array is 1, not 0
      return currentErrors.length == 1;
    },
    resetErrorMessages: function resetErrorMessages() {
      this.error.type = "";
      this.error.advice = "";
      this.error.bottling = "";
      this.error.temperature = "";
      this.error.orientation = "";
      this.error.soil = "";
      this.error.note = "";
      this.error.vignification = "";
      this.error.composition = "";
      this.error.supplierSelect = "";
      this.error.supplierPrice = "";
      this.error.cogs_euro_ex_vat = "";
      this.error.rangeAccessibility = "";
      this.error.rarity = "";
      this.error.name = "";
      this.error.vintage = "";
      this.error.alcohol_level_category = "";
      this.error.producer = "";
      this.error.region = "";
      this.error.regionSub = "";
      this.error.appellation = "";
      this.error.hs_code = "";
      this.error.accountancy_code = "";
      this.error.buy_limit = "";
      this.error.clone = "";
      this.error.id_ttb = "";
      this.error.casing = "";
      this.error.buy_limit_casing = "";
      this.error.cuvee = "";
    },
    callToUpdate: function callToUpdate() {
      this.duplicateWines = [];
      this.$router.push({
        query: {
          edit: true
        }
      });
      this.isCloning = false;
      this.originalWine = null;
    },
    callToClone: function callToClone() {
      this.duplicateWines = [];
      this.$router.push({
        query: {
          edit: true
        }
      });
      this.isCloning = true;
      this.originalWine = _objectSpread({}, this.wine);
      this.wine.externalIds = [];
      this.cloningOptions = {
        wineBaseId: this.wine.id_wine,
        transferCogs: true,
        transferCommissions: true,
        transferConditionalDiscounts: true
      };
    },
    cancel: function cancel() {
      if (!this.producerIdInPO && this.producerIdInPO !== 0) {
        if (this.$route.params.id === "new") {
          this.$router.back();
        } else {
          this.$router.replace({
            query: null
          });
          this.getWine();
          if (this.isCloning) {
            this.wine = this.originalWine;
            this.clearCloningOptions();
          }
          this.isCloning = false;
          this.originalWine = null;
          this.skuManual = false;
        }
      } else {
        this.$emit("closeNewWineDialog");
      }
    },
    clearCloningOptions: function clearCloningOptions() {
      this.cloningOptions = {
        wineBaseId: 0,
        transferCogs: false,
        transferCommissions: false,
        transferConditionalDiscounts: false
      };
    },
    deleteWine: function deleteWine() {
      var _this = this;
      _this.$refs.confirm.open("Delete", "Are you sure you want to delete this product ?", {
        color: "red"
      }).then(function (confirm) {
        if (confirm) {
          request("/v1/wine/" + _this.wine.id_wine, "delete", null, true, "api").then(function (response) {
            _this.$toasted.show("Product deleted.", {
              type: "success"
            });
            _this.$refs.return.backToList();
          }).catch(function (e) {
            var _e$response3;
            if (e !== null && e !== void 0 && (_e$response3 = e.response) !== null && _e$response3 !== void 0 && (_e$response3 = _e$response3.data) !== null && _e$response3 !== void 0 && (_e$response3 = _e$response3.value) !== null && _e$response3 !== void 0 && _e$response3.message) {
              _this.$toasted.show(e.response.data.value.message, {
                type: "warning"
              });
            } else {
              _this.$toasted.show("Unable to delete the product.", {
                type: "error"
              });
            }
            throw e;
          });
        }
      });
    },
    closeWineStockListModal: function closeWineStockListModal() {
      var _this13 = this;
      this.$nextTick(function () {
        _this13.wineStockKey = null;
        _this13.currentWine = null;
        _this13.currentQuantity = 0;
      });
    },
    addItemToCart: function addItemToCart(wine, casingId) {
      var _arguments = arguments,
        _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _wine$stocks;
        var isFromWineStockModal, quantityFromStockModal, quantity, casing, isBypassingReachedBuyLimit, _this15, currentOrder, _this16, _this17, index;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              isFromWineStockModal = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : false;
              quantityFromStockModal = _arguments.length > 3 && _arguments[3] !== undefined ? _arguments[3] : 0;
              if (!(_this14.thirdPartyOrder && !orderHandler.getThirdPartyUserSelected())) {
                _context8.next = 5;
                break;
              }
              _this14.$toasted.show("You should choose a user before adding an item to your cart.", {
                type: "warning"
              });
              return _context8.abrupt("return");
            case 5:
              quantity = 1;
              if (quantityFromStockModal > 0) {
                quantity = quantityFromStockModal;
                _this14.wineStockKey = null;
                _this14.currentWine = null;
                _this14.currentQuantity = 0;
              } else {
                // We get the quantity set by the user, default 1
                quantity = _this14.addQuantity;
              }
              if (!(!isFromWineStockModal && isAdminNotConsultant(_this14.loggedUserData) && ((_wine$stocks = wine.stocks) === null || _wine$stocks === void 0 ? void 0 : _wine$stocks.length) >= 1)) {
                _context8.next = 14;
                break;
              }
              _this14.wineStockKey = wine.id_wine;
              _this14.currentWine = wine;
              _this14.currentQuantity = parseInt(quantity);
              _this14.$nextTick(function () {
                _this14.$refs.WineStockListModal.open();
              });
              _context8.next = 35;
              break;
            case 14:
              _this14.isAddingToCart = [].concat(_toConsumableArray(_this14.isAddingToCart), [wine.id_wine]);

              // Perform casing adjustment
              casing = casingId.match(/\d+/)[0];
              quantity = quantity * casing;
              isBypassingReachedBuyLimit = null;
              _this15 = _this14;
              _context8.next = 21;
              return orderHandler.addItemToCart(wine, quantity, casingId, _this15.$toasted, _this15).catch(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(e) {
                  var _e$value;
                  var _e$value$errorMessage, _e$value2, _e$value3, errorMessage;
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        _this15.isAddingToCart = _toConsumableArray(_this15.isAddingToCart.filter(function (x) {
                          return x !== wine.id_wine;
                        }));
                        if (!((e === null || e === void 0 || (_e$value = e.value) === null || _e$value === void 0 ? void 0 : _e$value.errorCode) === buyLimitErrors.BUY_LIMIT_REACHED.value && hasRole(process.env.VUE_APP_ROLES_BYPASS_ALL_BUY_LIMITS))) {
                          _context6.next = 7;
                          break;
                        }
                        _this14.$toasted.clear();
                        errorMessage = (_e$value$errorMessage = e === null || e === void 0 || (_e$value2 = e.value) === null || _e$value2 === void 0 ? void 0 : _e$value2.errorMessage) !== null && _e$value$errorMessage !== void 0 ? _e$value$errorMessage : e === null || e === void 0 || (_e$value3 = e.value) === null || _e$value3 === void 0 ? void 0 : _e$value3.message;
                        _context6.next = 6;
                        return _this15.$refs.confirm.open("Bypass buy limits for order", "".concat(errorMessage, "  ").concat(buyLimitErrors.BUY_LIMIT_REACHED.text), {
                          color: "red"
                        });
                      case 6:
                        isBypassingReachedBuyLimit = _context6.sent;
                      case 7:
                        return _context6.abrupt("return");
                      case 8:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 21:
              if (!isBypassingReachedBuyLimit) {
                _context8.next = 33;
                break;
              }
              currentOrder = orderHandler.getCurrentOrder();
              _this14.isAddingToCart = [].concat(_toConsumableArray(_this14.isAddingToCart), [wine.id_wine]);
              if (!currentOrder) {
                _context8.next = 30;
                break;
              }
              _this16 = _this14;
              _context8.next = 28;
              return request("/v1/order/".concat(currentOrder.id_order, "/bypass"), "put", null, true, "api").then(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(resp) {
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return orderHandler.addItemToCart(wine, quantity, casingId, _this16.$toasted, _this16, true).catch(function () {
                          _this16.isAddingToCart = _toConsumableArray(_this16.isAddingToCart.filter(function (x) {
                            return x !== wine.id_wine;
                          }));
                        });
                      case 2:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 28:
              _context8.next = 33;
              break;
            case 30:
              _this17 = _this14;
              _context8.next = 33;
              return orderHandler.addItemToCart(wine, quantity, casingId, _this14.$toasted, _this14, true).catch(function () {
                _this17.isAddingToCart = _toConsumableArray(_this17.isAddingToCart.filter(function (x) {
                  return x !== wine.id_wine;
                }));
              });
            case 33:
              index = _this14.isAddingToCart.indexOf(wine.id_wine);
              _this14.isAddingToCart.splice(index, 1);
            case 35:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    toggleFavorite: function toggleFavorite(wine) {
      wine.favorite = !wine.favorite;
      var _this = this;
      // Save the order serverside before saving it in the local storage
      request("/v1/user/favorites/" + wine.id_wine + "?isWineToAdd=" + wine.favorite, "put", null, true, "api").then(function (response) {
        if (wine.favorite) {
          _this.$toasted.show("Product added to your favorites.", {
            type: "success"
          });
        } else {
          _this.$toasted.show("Product removed from your favorites.", {
            type: "success"
          });
        }
      });
    },
    formatPriceCartCurrency: function formatPriceCartCurrency(price) {
      var multiplier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return formatEurPriceInUsedCurrencyForCartAndExplore(price, multiplier, true);
    },
    getThirdPartyUserSelected: function getThirdPartyUserSelected() {
      return orderHandler.getThirdPartyUserSelected();
    },
    goToProducerDetails: function goToProducerDetails(producerId) {
      var detailsRoute = "";
      var returnRoute = {
        return: this.$route.name,
        idWine: this.wine.id_wine
      };
      if (this.loggedUserData.userGroup == "ADMIN") {
        detailsRoute = "adminProducerDetails";
        returnRoute = "adminProducerList";
      } else {
        detailsRoute = "userProducerDetails";
        returnRoute = null;
      }
      return {
        name: detailsRoute,
        params: {
          id: producerId,
          returnRoute: returnRoute
        }
      };
    },
    updateRange: function updateRange() {
      var bottling = +this.wine.bottling || REGULAR_BOTTLING;
      var price_per_regular_bottle = +this.wine.cogs_euro_ex_vat / bottling * REGULAR_BOTTLING;
      this.wine.id_range = this.ranges.find(function (x) {
        return (!x.price_min || x.price_min < price_per_regular_bottle) && (!x.price_max || x.price_max >= price_per_regular_bottle);
      }).id_range;
    },
    upload: function upload() {
      this.fetchWineDocuments();
      this.uploadAdditionalData.tagId = null;
    },
    fetchDocumentTags: function fetchDocumentTags() {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this18$gettingDocume;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this18.gettingDocumentTags.isPending = true;
              (_this18$gettingDocume = _this18.gettingDocumentTags.cancellationToken) === null || _this18$gettingDocume === void 0 || _this18$gettingDocume.cancel();
              _this18.gettingDocumentTags.cancellationToken = axios.CancelToken.source();
              _this = _this18;
              _context9.next = 6;
              return request("/v1/document-tags/all", "get", null, true, "api", null, _this.gettingDocumentTags.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get list of tags", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 6:
              response = _context9.sent;
              _this18.gettingDocumentTags.results = _toConsumableArray(response.data.items);
              _this18.gettingDocumentTags.results = _this18.gettingDocumentTags.results.filter(function (x) {
                return x.id !== DOCUMENT_TAGS.ORDER_FINAL_INVOICE.tagId;
              });
              _this18.gettingDocumentTags.isPending = false;
            case 10:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    fetchWineDocuments: function fetchWineDocuments() {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this = _this19;
              _this19.isLoadingFiles = true;
              _context10.next = 4;
              return request("/v1/wine/".concat(_this19.wine.id_wine, "/files"), "get", null, true, "api", null, _this19.filesCancelToken).catch(function (e) {
                _this.$toasted.show("Unable to load files.", {
                  type: "error"
                });
                _this.isLoadingFiles = false;
                throw e;
              });
            case 4:
              response = _context10.sent;
              if (response) _this19.wineDocuments = _toConsumableArray(response.data);
              _this19.isLoadingFiles = false;
            case 7:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    removeFile: function removeFile(id) {
      var _this20 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var confirmed, _this21;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this20.isMakingDrawerStateless = true;
              _context11.next = 3;
              return _this20.$refs.confirm.open("Cancel", "Are you sure you want to remove this file?", {
                color: "red"
              });
            case 3:
              confirmed = _context11.sent;
              if (!confirmed) {
                _context11.next = 10;
                break;
              }
              _this20.isLoadingFiles = true;
              _this21 = _this20;
              _context11.next = 9;
              return request("/v1/wine/".concat(_this20.wine.id_wine, "/files/").concat(id), "delete", null, true, "api").catch(function (e) {
                _this21.$toasted.show("Unable to remove this purchase order.", {
                  type: "error"
                });
                _this21.isLoadingFiles = false;
                throw e;
              });
            case 9:
              _this20.fetchWineDocuments();
            case 10:
              _this20.isMakingDrawerStateless = false;
            case 11:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    openFileUrl: function openFileUrl(url) {
      window.open(url, "_blank");
    },
    openTagsDialog: function openTagsDialog() {
      this.$refs.ManageDocumentsTagsDialog.openDialog();
    },
    openAddTagToDocument: function openAddTagToDocument(idDocument) {
      this.$refs.AddTagToDocumentDialog.openDialog(idDocument, this.documentTypes.WINE);
    },
    removeTagFromDocument: function removeTagFromDocument(idDocument) {
      var _this22 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this = _this22;
              _this.$refs.confirmDocumentDrawer.open("Delete", "Are you sure you want to delete this tag ?", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(confirm) {
                  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                    while (1) switch (_context12.prev = _context12.next) {
                      case 0:
                        if (!confirm) {
                          _context12.next = 3;
                          break;
                        }
                        _context12.next = 3;
                        return request("/v1/document-tags/type/".concat(_this.documentTypes.WINE.id), "delete", {
                          idDocument: idDocument
                        }, true, "api").then(function (response) {
                          _this.tagListChangedUpdate();
                        }).catch(function (error) {
                          _this.$toasted.show("Unable to remove tag from document.", {
                            type: "error"
                          });
                          throw error;
                        });
                      case 3:
                      case "end":
                        return _context12.stop();
                    }
                  }, _callee12);
                }));
                return function (_x4) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    tagListChangedUpdate: function tagListChangedUpdate() {
      this.fetchWineDocuments();
      this.fetchDocumentTags();
      this.$refs.AddTagToDocumentDialog.fetchDocumentTags();
      this.$refs.ManageDocumentsTagsDialog.fetchDocumentTags();
    },
    refreshUnitPriceAccordingToQuantity: function refreshUnitPriceAccordingToQuantity() {
      if (!this.isAddWine) {
        var _this$wine$discounts;
        this.discountAmount = 0;
        this.wineCasingQuantity = this.casingIdSelected.match(/\d+/)[0];
        if (((_this$wine$discounts = this.wine.discounts) === null || _this$wine$discounts === void 0 ? void 0 : _this$wine$discounts.length) > 0) {
          var bottles = this.addQuantity * this.casingIdSelected.match(/\d+/)[0];
          var discounts = this.wine.discounts.filter(function (x) {
            return x.bottle_treshold <= bottles;
          });
          if (discounts.length > 0) {
            discounts.sort(function (a, b) {
              return b.bottle_treshold - a.bottle_treshold;
            });
            this.discountAmount = this.wine.customerPriceIncludeDefaultShippingCurrency - discounts[0].customerPriceIncludeDefaultShippingCurrency;
          }
        }
      }
    },
    openDiscounts: function openDiscounts() {
      var _this23 = this;
      this.isConditionalDiscountV2ModalShown = true;
      this.$nextTick(function () {
        _this23.$refs.ConditionalDiscountV2Modal.open();
      });
    },
    closeDiscounts: function closeDiscounts() {
      var _this24 = this;
      this.isConditionalDiscountV2ModalShown = false;
      this.$nextTick(function () {
        _this24.getWine();
      });
    },
    openOldDiscounts: function openOldDiscounts() {
      var _this25 = this;
      this.isConditionalDiscountModalShown = true;
      this.$nextTick(function () {
        _this25.$refs.ConditionalDiscountModal.open();
      });
    },
    closeOldDiscounts: function closeOldDiscounts() {
      var _this26 = this;
      this.isConditionalDiscountModalShown = false;
      this.$nextTick(function () {
        _this26.getWine();
      });
    },
    openSupplierPrices: function openSupplierPrices() {
      var _this27 = this;
      this.isWineSupplierPriceModalShown = true;
      this.$nextTick(function () {
        _this27.$refs.wineSupplierPriceModal.open();
      });
    },
    closeSupplierPrices: function closeSupplierPrices() {
      this.isWineSupplierPriceModalShown = false;
    },
    openDuplicateList: function openDuplicateList() {
      var _this28 = this;
      this.isDuplicateListDialogShown = true;
      this.$nextTick(function () {
        _this28.$refs.WineDuplicateListDialog.open();
      });
    },
    closeDuplicateList: function closeDuplicateList() {
      this.isDuplicateListDialogShown = false;
    },
    fetchDuplicateWines: function fetchDuplicateWines() {
      var _this29 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _this29$fetchDuplicat;
        var _this;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              (_this29$fetchDuplicat = _this29.fetchDuplicateWinesToken) === null || _this29$fetchDuplicat === void 0 || _this29$fetchDuplicat.cancel();
              _this29.fetchDuplicateWinesToken = axios.CancelToken.source();
              _this = _this29;
              _context14.next = 5;
              return request("/v1/wine/duplicate", "post", _this29.wine, true, "api", null, _this29.fetchDuplicateWinesToken).then(function (response) {
                _this.duplicateWines = response.data.value;
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load the duplicate wines.");
                  handleErrorData(_this, errorData);
                  throw e;
                }
              });
            case 5:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    openAppellationPopin: function openAppellationPopin() {
      var _this30 = this;
      this.appellationPopinShown = true;
      this.$nextTick(function () {
        _this30.$refs.appellationPopin.open();
      });
    },
    closeAppellationPopin: function closeAppellationPopin(response) {
      var _this31 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var identifier;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _this31.appellationPopinShown = false;
              _this31.refreshClassifications();
              _context15.next = 4;
              return _this31.refreshRegionsAndAppellations();
            case 4:
              if (response.confirmed) {
                identifier = +response.data.value;
                if (!_this31.regions.some(function (r) {
                  return r.appellations.some(function (a) {
                    return a.id_appellation === identifier;
                  });
                })) {
                  _this31.wine.region = {};
                  _this31.changeRegion();
                } else {
                  _this31.wine.region = _this31.regions.find(function (x) {
                    return x.appellations.some(function (y) {
                      return y.id_appellation === identifier;
                    });
                  });
                  _this31.wine.appellation = _this31.wine.region.appellations.find(function (x) {
                    return x.id_appellation === identifier;
                  });
                  _this31.changeAppellation();
                }
              }
            case 5:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    refreshRegionsAndAppellations: function refreshRegionsAndAppellations() {
      var _this32 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _this = _this32;
              _context16.next = 3;
              return request("/v1/regions?variant=wine-regions", "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, {}, "Unable to refresh regions and appellations");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 3:
              response = _context16.sent;
              if (response.data !== null) {
                _this32.regions = _toConsumableArray(response.data.map(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    displayName: "".concat(x.country.printable_name, " / ").concat(x.name)
                  });
                }));
              }
            case 5:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    refreshClassifications: function refreshClassifications() {
      var _this33 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _this = _this33;
              _context17.next = 3;
              return request("/v1/appellations/classifications", "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, {}, "Unable to refresh classifications list");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 3:
              response = _context17.sent;
              if (response.data !== null) _this33.classifications = _toConsumableArray(response.data);
            case 5:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }))();
    },
    openDosagePopin: function openDosagePopin() {
      var _this34 = this;
      this.dosagePopinShown = true;
      this.$nextTick(function () {
        _this34.$refs.dosagePopin.open();
      });
    },
    closeDosagePopin: function closeDosagePopin(response) {
      var _this35 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var _this35$dosages, identifier;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _this35.dosagePopinShown = false;
              _context18.next = 3;
              return _this35.refreshDosages();
            case 3:
              if (response.confirmed) {
                identifier = +response.data.value;
                if (!((_this35$dosages = _this35.dosages) !== null && _this35$dosages !== void 0 && _this35$dosages.some(function (x) {
                  return x.id_dosage === identifier;
                }))) {
                  _this35.wine.dosage = null;
                } else {
                  _this35.wine.dosage = identifier;
                }
              }
            case 4:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }))();
    },
    refreshDosages: function refreshDosages() {
      var _this36 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _this = _this36;
              _context19.next = 3;
              return request("/v1/appellations/dosages", "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, {}, "Unable to refresh dosages");
                handleErrorData(_this, errorData);
              });
            case 3:
              response = _context19.sent;
              if (response.data !== null) _this36.dosages = _toConsumableArray(response.data);
            case 5:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }))();
    },
    openDenominationPopin: function openDenominationPopin() {
      var _this37 = this;
      this.denominationPopinShown = true;
      this.$nextTick(function () {
        _this37.$refs.denominationPopin.open();
      });
    },
    closeDenominationPopin: function closeDenominationPopin(response) {
      var _this38 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var identifier, regions, hasRegion, matchingRegion, matchingAppellation, matchingDenomination;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _this38.denominationPopinShown = false;
              _context20.next = 3;
              return _this38.refreshRegionsAndAppellations();
            case 3:
              if (response.confirmed) {
                identifier = +response.data.value;
                regions = _toConsumableArray(_this38.regions);
                hasRegion = regions.some(function (region) {
                  return region.appellations.some(function (appellation) {
                    return appellation.denominations.some(function (denomination) {
                      return denomination.id_appellation == identifier;
                    });
                  });
                });
                if (!hasRegion) {
                  _this38.wine.region = {};
                  _this38.changeRegion();
                } else {
                  matchingRegion = regions.find(function (region) {
                    return region.appellations.some(function (appellation) {
                      return appellation.denominations.some(function (denomination) {
                        return denomination.id_appellation == identifier;
                      });
                    });
                  });
                  _this38.wine.region = _objectSpread({}, matchingRegion);
                  matchingAppellation = matchingRegion.appellations.find(function (appellation) {
                    return appellation.denominations.some(function (denomination) {
                      return denomination.id_appellation == identifier;
                    });
                  });
                  _this38.wine.appellation = _objectSpread({}, matchingAppellation);
                  matchingDenomination = matchingAppellation.denominations.find(function (denomination) {
                    return denomination.id_appellation == identifier;
                  });
                  _this38.wine.denomination = _objectSpread({}, matchingDenomination);
                  _this38.changeDenomination();
                }
              }
            case 4:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }))();
    },
    openScheduledCogs: function openScheduledCogs() {
      var _this39 = this;
      this.isScheduledCogsModalShown = true;
      this.$nextTick(function () {
        _this39.$refs.ScheduledCogsModal.open();
      });
    },
    closeScheduledCogs: function closeScheduledCogs() {
      this.isScheduledCogsModalShown = false;
    },
    changeIsPrecisingAlcoholLevel: function changeIsPrecisingAlcoholLevel() {
      if (!this.isPrecisingAlcoholLevel) {
        this.wine.alcohol_level = null;
      }
    },
    changePrecisingAlcoholLevel: function changePrecisingAlcoholLevel(value) {
      this.wine.alcohol_level_category = alcoholLevelCategories.find(function (x) {
        return x.minValue <= value && x.maxValue > value;
      }).id;
    },
    getRequiredTastingPhotos: function getRequiredTastingPhotos() {
      var _this40 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var _this40$wine;
        var _this40$wine2, _this41, formSearch, paramsQuery, response;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              if (!(_this40.tastingPhotos.canManage && ((_this40$wine = _this40.wine) === null || _this40$wine === void 0 ? void 0 : _this40$wine.id_wine) > 0)) {
                _context21.next = 11;
                break;
              }
              _this40.tastingPhotos.required.isSearchPending = true;
              _this40.tastingPhotos.required.items = [];
              _this41 = _this40;
              formSearch = {
                wineIds: [+((_this40$wine2 = _this40.wine) === null || _this40$wine2 === void 0 ? void 0 : _this40$wine2.id_wine)],
                allowedStatus: [TASTING_PHOTOS.REQUIRED.STATUS.TO_TAKE.id, TASTING_PHOTOS.REQUIRED.STATUS.PARTIALLY_TAKEN.id]
              };
              paramsQuery = Object.encodeToUri(formSearch);
              _context21.next = 8;
              return request("/v1/tasting-photos/required?params=".concat(paramsQuery), "get", null, true, "api").catch(function (e) {
                _this41.tastingPhotos.required.isSearchPending = false;
                _this41.$toasted.show("Unable to load required photos.", {
                  type: "error"
                });
                throw e;
              });
            case 8:
              response = _context21.sent;
              _this40.tastingPhotos.required.items = _toConsumableArray(response.data.value);
              _this40.tastingPhotos.required.isSearchPending = false;
            case 11:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }))();
    },
    routeToTastingPhotos: function routeToTastingPhotos() {
      if (isAdminNotConsultant(this.loggedUserData)) {
        var _this$wine2;
        return {
          name: "adminTastingPhotos",
          query: {
            tab: "required",
            wineId: +((_this$wine2 = this.wine) === null || _this$wine2 === void 0 ? void 0 : _this$wine2.id_wine)
          }
        };
      } else {
        var _this$wine3;
        return {
          name: "userTastingPhotos",
          query: {
            tab: "required",
            wineId: +((_this$wine3 = this.wine) === null || _this$wine3 === void 0 ? void 0 : _this$wine3.id_wine)
          }
        };
      }
    },
    startAddRegion: function startAddRegion() {
      var _this42 = this;
      this.regionForm.editedId = null;
      this.regionForm.initAddFormValues = {
        productType: this.wineIsSpirit ? "spirits" : "wines"
      };
      this.$nextTick(function () {
        _this42.$refs.regionForm.open();
      });
    },
    startAddRegionSub: function startAddRegionSub() {
      var _this43 = this;
      this.regionForm.editedId = +this.wine.region.id;
      this.$nextTick(function () {
        _this43.$refs.regionForm.open();
      });
    },
    refreshRegionList: function refreshRegionList() {
      var _this44 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var response;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _this44.regionForm.refreshingList.isPending = true;
              _context22.next = 3;
              return request("/v1/regions?variant=wine-regions", "get", null, true, "api").catch(function (e) {
                _this.regionForm.refreshingList.isPending = false;
                _this.$toasted.show("Unable to reload regions.", {
                  type: "error"
                });
                throw e;
              });
            case 3:
              response = _context22.sent;
              _this44.regions = _toConsumableArray(response.data.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  displayName: "".concat(x.country.printable_name, " / ").concat(x.name)
                });
              }));
              _this44.producregionForm.refreshingListerList.isPending = false;
            case 6:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      }))();
    },
    addNewExternalid: function addNewExternalid() {
      var guid = crypto.randomUUID();
      this.wine.externalIds.push({
        newGuid: guid,
        id: null,
        externalPlatformName: this.newExternalId.externalPlatformName,
        externalPlatformId: this.newExternalId.externalPlatformId
      });
      this.newExternalId.externalPlatformName = "HAL";
      this.newExternalId.externalPlatformId = "";
      this.newExternalIdIsConfiguring = false;
    },
    confirmRemoveExternalId: function confirmRemoveExternalId(externalId) {
      var _this45 = this;
      this.$refs.confirm.open("Remove", "Are you sure you want to remove this external reference ?", {
        color: "red"
      }).then(function (confirm) {
        if (confirm) {
          _this45.removeExternalId(externalId);
        }
      });
    },
    removeExternalId: function removeExternalId(externalId) {
      if (externalId.id > 0) {
        this.wine.externalIds = this.wine.externalIds.filter(function (x) {
          return x.id !== externalId.id;
        });
      } else {
        this.wine.externalIds = this.wine.externalIds.filter(function (x) {
          return x.newGuid !== externalId.newGuid;
        });
      }
    },
    setInitialCogs: function setInitialCogs() {
      this.initialCogs = this.wine.cogs_euro_ex_vat;
    },
    openWineCogsHistoryModal: function openWineCogsHistoryModal() {
      var _this46 = this;
      this.$nextTick(function () {
        _this46.$refs.WineCogsHistoryModal.open();
      });
    },
    openPricesPostingHistoryModal: function openPricesPostingHistoryModal() {
      var _this47 = this;
      this.$nextTick(function () {
        _this47.$refs.pricePostingWineConditionalDiscountHistoryRef.open();
      });
    },
    goToAddProducer: function goToAddProducer() {
      return {
        name: "adminProducerDetails",
        params: {
          id: 0
        }
      };
    },
    refreshProducerList: function refreshProducerList() {
      var _this48 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var response;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _this48.producerList.isPending = true;
              _context23.next = 3;
              return request("/v1/producers/all/for-selectors", "get", null, true, "api").catch(function (e) {
                _this.producerList.isPending = false;
                _this.$toasted.show("Unable to reload producer list.", {
                  type: "error"
                });
                throw e;
              });
            case 3:
              response = _context23.sent;
              _this48.producers = _toConsumableArray(response.data.value);
              _this48.producerList.isPending = false;
            case 6:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }))();
    },
    fetchSuppliers: function fetchSuppliers() {
      var _this49 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
        var _this49$fetchSupplier;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              (_this49$fetchSupplier = _this49.fetchSuppliersToken) === null || _this49$fetchSupplier === void 0 || _this49$fetchSupplier.cancel();
              _this49.fetchSuppliersToken = axios.CancelToken.source();
              _this = _this49;
              _context24.next = 5;
              return request("/v1/suppliers", "get", null, true, "api", null, _this49.fetchSuppliersToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load suppliers.", {
                    type: "error"
                  });
                  return;
                }
              });
            case 5:
              response = _context24.sent;
              if (response) {
                _this49.suppliers = response.data.value.map(function (supplier) {
                  return _objectSpread(_objectSpread({}, supplier), {}, {
                    display_name: "".concat(supplier.name, " (").concat(supplier.producerId ? "producer" : "supplier", ")")
                  });
                });
              }
            case 7:
            case "end":
              return _context24.stop();
          }
        }, _callee24);
      }))();
    },
    changeSupplier: function changeSupplier(supplierId) {
      this.wine.supplierPrice.supplierId = supplierId;
    },
    fetchSuppliersWhenItemsUpdated: function fetchSuppliersWhenItemsUpdated(supplierId) {
      var _this50 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _context25.next = 2;
              return _this50.fetchSuppliers();
            case 2:
              _this50.changeSupplier(supplierId);
              _this50.$refs.supplierSelect.updateModel(supplierId);
            case 4:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      }))();
    },
    goToSupplierPricesList: function goToSupplierPricesList() {
      return {
        name: "adminStockList",
        query: {
          tab: "supplierPrices"
        }
      };
    },
    scrollTo: scrollTo,
    displayPrice: displayPrice,
    formatPrice: formatPrice,
    isAdminNotConsultant: isAdminNotConsultant,
    isConsultantOrHolding: isConsultantOrHolding,
    isConsultantNotHolding: isConsultantNotHolding,
    isIndividual: isIndividual,
    isUserBuyerGroup: isUserBuyerGroup,
    hasBypassBuyLimit: hasBypassBuyLimit,
    userHasByPassLimit: userHasByPassLimit,
    filterVAutocomplete: filterVAutocomplete,
    filterDecimalKey: filterDecimalKey
  }
};